export function lerp(a, b, t) {
  return t * (b - a) + a;
}
